import { RestApiArrayResultMobileAppsStatistics } from '@flipdish/api-client-typescript';
import { QueryObserverResult, RefetchOptions, useQuery } from 'react-query';

import { mobileAppsService } from '../components/SalesChannels/MobileApps/mobileApps.services';
import { AppType } from '../components/SalesChannels/MobileApps/types';

export const getMobileAppStatisticsQueryKey = 'mobileAppStatistics';
export function useQueryMobileAppStatisticsHook(
  appId: string,
  appTypes: AppType[],
  enabled: boolean,
  refetchOnMount = false
): {
  isFetching: boolean;
  isLoading: boolean;
  data?: RestApiArrayResultMobileAppsStatistics;
  isError: boolean;
  isFetched: boolean;
  refetch: (
    options?: RefetchOptions
  ) => Promise<QueryObserverResult<RestApiArrayResultMobileAppsStatistics, unknown>>;
} {
  const {
    isFetching,
    isLoading,
    data,
    isError,
    isFetched,
    refetch,
  } = useQuery<RestApiArrayResultMobileAppsStatistics>(
    [getMobileAppStatisticsQueryKey, appId, appTypes],
    () => mobileAppsService.getStatistics(appId, appTypes),
    {
      cacheTime: 1000 * 30,
      enabled: enabled,
      refetchOnMount: refetchOnMount,
    }
  );
  return {
    isFetching,
    isLoading,
    data,
    isError,
    isFetched,
    refetch,
  };
}
